import { CustomerMailer } from '@/modules/Customer/types'
import MailerCard from './MailerCard'

interface DefaultMailerViewProps {
    mailers: CustomerMailer[]
    onEdit: (mailer: CustomerMailer) => void
    onEmailClick?: (email: string) => void
    selectedEmail?: string | null
}

const DefaultMailerView: React.FC<DefaultMailerViewProps> = ({
    mailers,
    onEdit,
    onEmailClick,
    selectedEmail,
}) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
            {mailers.map((mailer) => (
                <MailerCard
                    key={mailer.customer_mailer_id}
                    mailer={mailer}
                    onEdit={onEdit}
                    onEmailClick={onEmailClick}
                    selectedEmail={selectedEmail}
                />
            ))}
        </div>
    )
}

export default DefaultMailerView
